import { render, staticRenderFns } from "./task-list-ca.vue?vue&type=template&id=544b6ab0&"
import script from "./task-list-ca.vue?vue&type=script&lang=js&"
export * from "./task-list-ca.vue?vue&type=script&lang=js&"
import style0 from "./task-list-ca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports